export enum AutocompleteTemplateType {
	Defaut,
	Checkbox,
	Custom
}
